/**
 * Éditeur — sondage déjà voté : charger les votes pour avertir avant de
 * retirer une date choisie, et libeller cette date dans l'avertissement.
 *
 * get_poll_responses est la RPC des résultats (SECURITY DEFINER) : elle rend
 * les votes au créateur — compte propriétaire, ou invité muni du jeton.
 * Échec de lecture → null (≠ [] « aucun vote ») : l'appelant recâble alors
 * par précaution — la base voit les votes, seul l'avertissement saute.
 */
import { supabase } from "./supabase";
import { getOwnerTokenForPoll } from "./guestIdentityService";
import type { BuiltPollOption } from "./buildPollOptions";

export async function loadResponsesForEdit(
  pollId: string,
): Promise<Array<{ response_data?: Record<string, unknown> | null }> | null> {
  try {
    const token = getOwnerTokenForPoll(pollId);
    const { data, error } = await supabase.rpc("get_poll_responses", {
      p_poll_id: pollId,
      ...(token ? { p_owner_token: token } : {}),
    });
    if (error || !Array.isArray(data)) return null;
    return data as Array<{ response_data?: Record<string, unknown> | null }>;
  } catch {
    return null;
  }
}

/** « jeudi 8 octobre, 18:00 - 19:00 » dans la langue de l'interface. */
export function formatOptionForWarning(
  option: BuiltPollOption,
  lang: string,
): string {
  const dates = option.date_group?.length
    ? option.date_group
    : [option.option_date];
  const day = dates
    .map((d) =>
      new Date(`${d}T00:00:00`).toLocaleDateString(lang, {
        weekday: "long",
        day: "numeric",
        month: "long",
      }),
    )
    .join(" – ");
  return option.time_label ? `${day}, ${option.time_label}` : day;
}
